import React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png";
import meeting1 from "../static/img/photo_2025-02-11_18-22-07.jpg";
import meeting2 from "../static/img/photo_2025-02-11_17-57-22.jpg";
import meeting3 from "../static/img/photo_2025-02-11_17-57-45.jpg";
import meeting4 from "../static/img/photo_2025-02-11_17-58-05.jpg";
import meeting5 from "../static/img/photo_2025-02-11_17-58-14.jpg";
import meeting6 from "../static/img/photo_2025-02-11_17-57-35.jpg";
import "./Microcredit.style.scss";

const WorkingMeeting: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on: false, index: 0});
    const [en, setEn] = useState(false);
    return (
        <div style={{marginTop:"30px",marginBottom:"20px"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",marginBottom:"50px"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>
            <h1>
                {en ? "Working meeting under the Erasmus+ DOMANI project" : "Робоча зустріч за проєктом Ерасмус+ DOMANI"}
            </h1>
            <p style={{fontWeight:"inherit",fontSize: "20px",margin:"30px 120px 30px 120px",textAlign:"left"}}>
                {en ? "On January 28-31, 2025, a meeting of the Erasmus + DOMANI project partners took place in Estonia.\n" +
                    "The main part of the meetings was held at the Open University of the Estonian University of Life Sciences (Tartu). " +
                    "Project coordinator Kristina Marran and her colleague, co-coordinator Anton Shkaruba, presented their vision of" +
                    " the procedure for the successful implementation of the activities planned in the project. Representatives of" +
                    " Karazin University, Prof. Maksymenko N.V. and Senior Lecturer Cherkashina N.I. reported on the results of" +
                    " the implementation of work package 2, in which Our University is the leader.\n" +
                    "On January 31, an excursion was organized to the Virtsjärvi Training Center of the Estonian University of Life Sciences," +
                    " located on the shores of the largest inland lake in Estonia. Informal communication also generated many ideas for" +
                    " joint work between both the main and associated project partners." :
                    "28-31 січня 2025 року в Естонії відбулась зустріч партнерів проєкту Ерасмус + DOMANI.\n" +
                    "Основну частину засідань проведено на базі Відкритого університету Естонського університету наук про життя (м. Тарту)." +
                    " Координатор проєкту Крістіна Марран та її колега – співкоординатор Антон Шкаруба представили своє бачення порядку" +
                    " успішної реалізації заходів, що заплановані в проєкті. Представники Каразінського університету проф. Максименко Н.В." +
                    " та ст. викл. Черкашина Н.І. доповіли результати виконання робочого пакету 2, у якому лідером є Наш університет. \n" +
                    "31 січня була організована екскурсія до Віртсьярвського Навчального центру Естонського університету природничих наук," +
                    " що знаходиться на узбережжі найбільшого внутрішнього озера Естонії. В неформальному спілкуванні також зародилось багато" +
                    " ідей для спільної роботи як основних так і асоційованих партнерів проєкту.\n"}
            </p>
            <div style={{display:"flex",flexDirection:"column",gap:"20px"}}>
                <div style={{display:"flex",flexDirection:"row",gap:"20px",justifyContent:"center"}} >
                    <img style={{width:"25%"}} src={meeting5} alt="meeting"/>
                    <img style={{width:"25%"}} src={meeting2} alt="meeting"/>
                    <img style={{width:"25%"}} src={meeting3} alt="meeting"/>
                </div>
                <div style={{display:"flex",flexDirection:"row",gap:"20px",justifyContent:"center"}} >
                    <img style={{width:"25%"}} src={meeting4} alt="meeting"/>
                    <img style={{width:"25%"}} src={meeting1} alt="meeting"/>
                    <img style={{width:"25%"}} src={meeting6} alt="meeting"/>
                </div>
            </div>
        </div>
    )
}
export default WorkingMeeting;